import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icon-google-play',
  standalone: true,
  imports: [],
  templateUrl: './icon-google-play.component.html',
  styleUrl: './icon-google-play.component.scss',
})
export class IconGooglePlayComponent {
  isDarkMode = input<boolean>(false);
}
